import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class EnvironmentService {

  constructor() {
  }

  getAPIBaseURL(type: any): string {
    switch (type) {
      case 'SPCAPI': return environment.SPCAPIBaseURL;
      case 'SPCAPICI': return environment.SPCAPICIBaseURL;
      case 'dfos': return environment.dfosUrl;
      case 'masterConfig': return environment.masterConfig;
      case 'NGTWAPI': return environment.NGTWBaseURL;
      case 'local': return 'http://localhost:4200/';
      default: return environment.SPCAPIBaseURL;
    }
  }

  getSubscriptionKey() {
    return environment.subscriptionKey;
  }
}
